const INPUT_THEME_CLASSES = {
  cloud:
    "border-navy-blue-04 bg-navy-blue-05 hover:border-navy-blue-03 focus:border-navy-blue-03 focus:bg-navy-blue-04 valid:bg-navy-blue-05 valid:border-navy-blue-04 active:text-white valid:text-white",
  zerto:
    "border-zerto-blue-07 bg-zerto-blue-08 hover:border-zerto-blue-06 hover:border-zerto-blue-06 focus:bg-zerto-blue-07 valid:bg-zerto-blue-08 valid:border-zerto-blue-07 hover:text-white active:text-white valid:text-white",
};

const EnterpriseInput = ({
  icon,
  placeholder,
  type = "text",
  value,
  onChange,
  onFocus,
  disabled = false,
  theme = "cloud",
  inputClassName = "",
  iconClassName = "",
  error = "",
}) => {
  const stateClasses = INPUT_THEME_CLASSES[theme] || INPUT_THEME_CLASSES.cloud;

  return (
    <div className="w-full">
      <div className="relative">
        {icon && (
          <img
            src={icon}
            alt="icon"
            className={` ${iconClassName} absolute top-1/2 -translate-y-1/2 left-3 size-4 md:size-[18px]`}
          />
        )}

        <input
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled}
          onFocus={onFocus}
          className={`py-3 pe-3 ps-10 rounded-lg border outline-none w-full disabled:opacity-70 disabled:cursor-not-allowed font-inter ${stateClasses} ${inputClassName}`}
        />
      </div>
      {error && <p className="text-red text-xs text-start">{error}</p>}
    </div>
  );
};

export default EnterpriseInput;
